/**
 * @file Public landing page — pages/Landing/PartnersPage.tsx.
 */

import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";
import "./ContentPage.css";

const PartnersPage: React.FC = () => {
  return (
    <div className="landing-root">
      <header className="landing-header flex justify-center items-center space-x-3 text-center py-4">
        <h1 className="landing-main-title text-4xl font-bold text-primary">
          ICoMEC
        </h1>
        <h2 className="landing-sub-title text-xl text-grayDark">
          Indian Construction Materials Embodied Carbon Data Base
        </h2>
      </header>

      <nav className="landing-nav">
        <Link to="/">Home</Link>
        <Link to="/join">Join</Link>
        <Link to="/impact">Impact</Link>
        <Link to="/research">Research and Analysis</Link>
        <Link to="/about">About</Link>
      </nav>

      <section className="content-page">
        <h1 className="content-title">Partners</h1>
        
        <div className="content-section">
          <p>
            We operate on a model of reciprocal technical exchange. Our partnerships are structured around shared learning and the advancement of the field.
          </p>
          <p>
            By prioritizing a mutual exchange of technical knowledge, we ensure that every collaboration contributes to the collective robustness of the ICoMEC database, benefiting the wider research and practice community.
          </p>
          <p>
            Our collaborative framework encompasses a diverse range of technical contributors and oversight bodies. These partnerships are essential for the validation and scaling of contextualized embodied carbon data:
          </p>
          <ul className="content-list">
            <li><strong>Academic Institutions & Research Organizations:</strong> Providing the theoretical foundation and peer-review oversight for Life Cycle Assessment (LCA) frameworks.</li>
            <li><strong>Public Bodies:</strong> Aligning platform outputs with national infrastructure requirements and regulatory standards.</li>
            <li><strong>Industry Associations:</strong> Facilitating the acquisition of representative manufacturing data and material supply chain variables.</li>
            <li><strong>Independent Subject Matter Experts:</strong> Offering specialized validation for specific material categories or statistical modeling techniques.</li>
          </ul>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-main">
          <div className="footer-left">
            <h2>ICoMEC</h2>
            <p>
              Indian Construction Materials Embodied
              <br /> Carbon Data Base
            </p>
          </div>

          <div className="footer-links">
            <div>
              <h4>About Us</h4>
              <ul>
                <li><Link to="/who-we-are">Who We Are</Link></li>
                <li><Link to="/what-we-do">What We Do</Link></li>
                <li><Link to="/leadership">Leadership</Link></li>
                <li><Link to="/partners">Partners</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/glossary">Glossary</Link></li>
              </ul>
            </div>
            <div>
              <h4>Resources</h4>
              <ul>
                {/* <li><Link to="/resource-library">Resource Library</Link></li> */}
                <li><Link to="/events">Events</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer-bottom">
        <p>
          <Link to="/cookies-policy">Cookies Policy</Link> · <Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/legal">Legal</Link> · <Link to="/terms-of-use">Terms of Use</Link>
          {/* · <Link to="/imprint">Imprint</Link> */}
        </p>
        <p>© 2026 CARBSE. All rights reserved.</p>
      </div>
    </div>
  );
};

/** React component — Partners Page. */
export default PartnersPage;
